//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackendServices from "@/services/backend-services.js";
import { fileNameFromContent } from "@/utils/name-parser.js";

export default {
  name: "AutomaticUploadsHistoryForm",
  components: {},
  props: ["value"],
  data: () => ({
    schedulingData: {},
    schedulingStatus: {
      created: {
        name: "mdi-alert-circle-outline",
        label: "Pendente",
        color: "yellow-4",
      },
      started: {
        name: "mdi-cached",
        label: "Iniciado",
        color: "blue-5",
      },
      successful: {
        name: "mdi-check-circle-outline",
        label: "Válido",
        color: "green-4",
      },
      failure: {
        name: "mdi-close-circle-outline",
        label: "Inválido",
        color: "red-4",
      },
    }
  }),
  computed: {},
  methods: {
    downloadFile() {
      BackendServices.schedulingHistoryFileDownloadRequest(this.value.id).then((response) => {
        const downloadUrl = window.URL.createObjectURL(
          new Blob([response.data])
        );
        const link = document.createElement("a");
        link.href = downloadUrl;
        let fileName = fileNameFromContent(response.headers["content-disposition"]);
        link.setAttribute("download", fileName); //any other extension
        document.body.appendChild(link);
        link.click();
        link.remove();
      });
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler: async function () {
      },
    },
  },
};
